import { Link } from "react-router-dom";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { INDUSTRIES, industryPath } from "@/data/industries";
import { Seo } from "@/lib/seo/Seo";

/**
 * Shown for unknown routes and unknown industry slugs.
 * Note: a client-rendered app answers HTTP 200 for these. The noindex tag keeps them out of search.
 * Real 404 status codes need server-side or prerender support (see docs/SEO_GUIDELINES.md).
 */
export default function NotFound() {
  return (
    <SiteLayout>
      <Seo title="Page not found | A Learning Lab India" description="This page could not be found." noindex />
      <section className="bg-brand-50 py-16 sm:py-20 lg:py-24" data-testid="not-found-page">
        <div className="mx-auto max-w-2xl px-4 text-center">
          <p className="text-sm font-bold uppercase tracking-widest text-brand-600">Error 404</p>
          <h1 className="mt-3 text-3xl font-bold tracking-tight text-ink sm:text-4xl">Page not found</h1>
          <p className="mt-4 text-base text-ink/70">
            The page you are looking for does not exist or has moved. Try one of these instead.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="inline-flex min-h-[44px] items-center rounded-lg bg-sun-500 px-6 py-3 text-sm font-bold text-ink transition-colors"
            >
              Back to home
            </Link>
            <Link
              to="/programs"
              className="inline-flex min-h-[44px] items-center rounded-full border border-ink bg-white px-6 py-3 text-sm font-bold text-ink transition-colors hover:bg-brand-50"
            >
              Browse programmes
            </Link>
          </div>

          <ul className="mt-10 flex flex-wrap justify-center gap-2">
            {INDUSTRIES.map((industry) => (
              <li key={industry.id}>
                <Link
                  to={industryPath(industry.id)}
                  className="inline-flex min-h-[44px] items-center rounded-full border border-brand-200 bg-white px-4 py-2 text-sm font-semibold text-ink transition-colors hover:border-brand-500 hover:bg-brand-50"
                >
                  {industry.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </SiteLayout>
  );
}
